import React, { Fragment } from 'react';
import './NewFooterV2.scss';
import { redirectWithCookies } from '../../utils/Utm'
import { SITE_CONSTANTS } from '../../utils/constants'

export default function NewFooter() {
    const footerSections = [
        {
            title: 'Mercos',
            links: [
                { name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true },
                { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true },
                { name: 'Integrações', url: '/integracao-erp/' },
                { name: 'Carreira', url: 'https://mercos.gupy.io/' },
                { name: 'Sobre Nós', url: '/sobre/' }
            ]
        },
        {
            title: 'Soluções',
            links: [
                { name: 'Força de vendas', url: '/forca-vendas/' },
                { name: 'E-commerce B2B', url: '/e-commerce-b2b/', highlight: true },
                { name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' },
                { name: 'Mercos Pay', url: '/mercos-pay', highlight: true },
                { name: 'Videochamada', url: '/videochamada/' }
            ]
        },
        {
            title: 'Segmentos',
            links: [
                { name: 'Indústrias', url: '/industrias/' },
                { name: 'Distribuidoras', url: '/distribuidoras/' },
                { name: 'Representantes', url: '/representantes-comerciais/' }
            ]
        },
        {
            title: 'Conteúdo',
            links: [
                { name: 'Blog', url: 'https://blog.mercos.com/' },
                { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI' },
                { name: <Fragment>E-commerce B2B: <br /> O que é?</Fragment>, url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank' }
            ]
        },
        {
            title: 'Suporte',
            links: [
                { name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb' },
                { 
                    name: '(47) 3481.8050',
                    custom: true,
                    content: (
                        <div className="support-info">
                            <div className="support-phone">(47) 3481.8050</div>
                            <div className="support-hours">
                            Atendimento de Segunda<br/>
                            a Quinta das 9h às 17h.<br/>
                            Sexta das 9h30 às 17h.
                            </div>
                        </div>
                    )
                }
            ]
        },
        {
            title: 'Transparência',
            links: [
                { name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' },
                { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' },
                { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank' },
                { name: 'Relatório da igualdade salarial', url: '/documentos/relatorio-igualdade-salarial-mercos.pdf' }
            ]
        }
    ];


    const renderLink = (link) => {
        if (link.custom) {
            return link.content;
        }

        return (
            <a
                className={`footer-link ${link.highlight ? 'highlight' : ''}`}
                href={link.redirect ? null : link.url}
                onClick={link.redirect ? () => redirectWithCookies(link.url) : null}
                target={link.target || null}
                rel={link.target === '_blank' ? 'noopener noreferrer' : null}
            >
                {link.name}
            </a>
        );
    };

    const socialLinks = [
        { name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' },
        { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' },
        { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' },
        { name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' },
        { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }
    ];

    return (
        <footer className="mercos-footer">
            <div className="footer-content">
                <div className="footer-main">
                    {footerSections.map((section, index) => (
                        <div className="footer-section" key={index}>
                            <p className="section-title">{section.title}</p>
                            <div className="section-links">
                                {section.links.map((link, linkIndex) => (
                                    <div className="link-item" key={linkIndex}>
                                        {renderLink(link)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="footer-app-download">
                    <div className="download-text">
                        <p className="download-title">Baixe o aplicativo e teste grátis</p>
                        <p>Junte-se a mais de {SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA} clientes que automatizaram e aumentaram suas vendas com a Mercos.</p>
                    </div>
                    <div className="app-buttons">
                        <a href="https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR" target="_blank" rel="noopener noreferrer" className="app-button">
                            <img src="/images/site/social/google-play.png" alt="Disponível no Google Play" />
                        </a>
                        <a href="https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628" target="_blank" rel="noopener noreferrer" className="app-button">
                            <img src="/images/site/social/app-store.png" alt="Baixar na App Store" />
                        </a>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-hr-line"></div>
                   <div className='footer-container'>
                        <div className="logo-container">
                            <a href="/" className="mercos-logo">
                                <img src="/images/mercos-nuvini.svg" alt="Mercos - uma empresa nuvini" />
                            </a>
                        </div>
                        
                        <div className="company-info">
                            Simplest Software Ltda CNPJ: 12.496.510/0001-80 Insc. Estadual: ISENTO Av. Rolf Wiest, 277 (7º andar) Bom Retiro - Joinville/SC | CEP: 89223-005
                        </div>
                        
                        <div className="social-links">
                            {socialLinks.map((social, index) => (
                                <a 
                                    key={index}
                                    href={social.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="social-link"
                                    aria-label={social.name}
                                >
                                    <img src={social.icon} alt={`Mercos no ${social.name}`} />
                                </a>
                            ))}
                            <span className="feito-com-amor">Feito com 💜</span>
                        </div>
                   </div>
                </div>
            </div>
        </footer>
    );
}


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/NewFooter/NewFooterV2.jsx